module.exports = __webpack_public_path__ + "img/Span-12.4a92b3ad.jpg";